module.exports = ({React,connect,Navli,Proplist,FormGroup,Route,SettingsActions})->

  {settingUpdate, settingsLoad, settingSave, settingRemove} = SettingsActions

  class InvoiceFooter extends React.Component
    constructor:(props)->
      super(props)
  
    onUpdate:(key,value)->
      @props.dispatch(settingUpdate(key,value))

    onSave:(key,value)->
      @onUpdate(key,value) if !value?
      val = if value? then value else @props.settings[key[0]][key[1]]
      @props.dispatch(settingSave(key,val))

    render:->
      <div className="col-md-10 settings-ecommerce-panel">
        <div className="row fullheight">
          <div className="col-md-12">
            <div className="duoPanel row4">
              <h4>NAFEMS Ecommerce Settings</h4>
              <div className="content padding form-horizontal">
                {if @props.settings && @props.settings.ecommerce
                    <div>
                      <FormGroup label="Invoice Footer Card">
                        <textarea
                              className="form-control"
                              rows={12}
                              style={{whiteSpace:"nowrap"}}
                              value={@props.settings.ecommerce.invoicefooterpaid ?= ""} 
                              onChange={(e)=> @onUpdate(['ecommerce','invoicefooterpaid'],e.target.value)} 
                              onBlur={(e)=> @onSave(['ecommerce','invoicefooterpaid'])} 
                        />
                      </FormGroup>
                      <FormGroup label="Invoice Footer - Invoice Me">
                        <textarea
                              className="form-control"
                              rows={12}
                              style={{whiteSpace:"nowrap"}}
                              value={@props.settings.ecommerce.invoicefooterunpaid ?= ""} 
                              onChange={(e)=> @onUpdate(['ecommerce','invoicefooterunpaid'],e.target.value)} 
                              onBlur={(e)=> @onSave(['ecommerce','invoicefooterunpaid'])} 
                        />
                      </FormGroup>
                    <br />
                    <h3>International Invoice  Addresses</h3>
                    <FormGroup label="German Billing Address">
                      <textarea rows={5} className="form-control"  
                              value={@props.settings.ecommerce.german_address ?= ""} 
                              onChange={(e)=> @onUpdate(['ecommerce','german_address'],e.target.value)} 
                              onBlur={(e)=> @onSave(['ecommerce','german_address'])} 
                      />
                    </FormGroup>
                    <FormGroup label="Austrian Billing Address">
                      <textarea rows={5} className="form-control"  
                              value={@props.settings.ecommerce.austrian_address ?= ""} 
                              onChange={(e)=> @onUpdate(['ecommerce','austrian_address'],e.target.value)} 
                              onBlur={(e)=> @onSave(['ecommerce','austrian_address'])} 
                      />
                    </FormGroup>
                    <FormGroup label="Swedish Billing Address">
                      <textarea rows={5} className="form-control"  
                              value={@props.settings.ecommerce.swedish_address ?= ""} 
                              onChange={(e)=> @onUpdate(['ecommerce','swedish_address'],e.target.value)} 
                              onBlur={(e)=> @onSave(['ecommerce','swedish_address'])} 
                      />
                    </FormGroup>
                    <FormGroup label="Czech Billing Address">
                      <textarea rows={5} className="form-control"  
                              value={@props.settings.ecommerce.czech_address ?= ""} 
                              onChange={(e)=> @onUpdate(['ecommerce','czech_address'],e.target.value)} 
                              onBlur={(e)=> @onSave(['ecommerce','czech_address'])} 
                      />
                    </FormGroup>
                    <FormGroup label="Netherlands Billing Address">
                      <textarea rows={5} className="form-control"  
                              value={@props.settings.ecommerce.netherlands_address ?= ""} 
                              onChange={(e)=> @onUpdate(['ecommerce','netherlands_address'],e.target.value)} 
                              onBlur={(e)=> @onSave(['ecommerce','netherlands_address'])} 
                      />
                    </FormGroup>

                    <br />
                    <h3>Disable Invoice Option (aka BANHAMMER!)</h3>
                    <p>Enter email addresses or partial email addresses to hide the invoice option in the checkout eg "@nafems.org" or "john@nafems.org". One address per line.</p>
                    <FormGroup label="Email Addresses">
                      <textarea rows={15} className="form-control"  
                              value={@props.settings.ecommerce.banhammer ?= ""} 
                              onChange={(e)=> @onUpdate(['ecommerce','banhammer'],e.target.value)} 
                              onBlur={(e)=> @onSave(['ecommerce','banhammer'])} 
                      />
                    </FormGroup>
                  </div>
                else 
                  <p>Loading</p>
                }
              </div>
            </div>
          </div>
        </div>
      </div>


  return connect(
    (state)=>
      settings: state.settings
    )(InvoiceFooter)